<template>
  <!-- -----------------  icon in the menu bar ---------------------------- -->
  <li
    data-component="quest-sub-menu"
    class="nav-item b-nav-dropdown dropdown"
    id="quest-dropdown"
    v-clickOutside="onClickedOutside"
    v-show="notOnProjectSelectionPage"
  >
    <a
      class="dropdown-toggle nav-link-custom"
      href="#"
      id="quest-menu"
      data-toggle="dropdown"
      aria-haspopup="true"
      :aria-expanded="opened"
      @click.prevent="toggle"
      ><b-icon-justify 
        class="icon"
        height="24px"
        width="24px"
      />
    </a>

    <ul
      class="dropdown-menu"
      :class="{ show: opened }"
      aria-labelledby="quest-menu"
    >
      <!-- -----------------  list of quests ------------------------------ -->
      <template v-for="(quest, index) in menu">
        <!-- ---------------  quests with sub-quests ---------------------- -->
        <li
          v-if="quest.type == 'menu'"
          class="dropdown-submenu dropleft"
          :key="'b-' + quest.id"
          :id="'b-quest-' + index"
          :name="'b-quest-' + quest.id"
          :class="{active:isActive(quest)}"
          :style="fontStyle(quest)"
          @click.prevent="toggleExpand(quest.id)"
        >
          <a class="dropdown-item-custom dropdown-toggle" href="#">{{
            quest.caption
          }}</a>
          <!-- sub-menu -->
          <ul
            class="dropdown-menu branch"
            v-if="quest.id === expandedQuest"
          >
            <li
              v-for="subQuest in quest.quests"
              :key="subQuest.id"
              :style="fontStyle(quest)"
              :id="'quest-' + subQuest.id"
            >
              <a
                href="#"
                class="dropdown-item"
                :class="{active:isActive(subQuest)}"
                :style="fontStyle(quest)"
                @click.prevent="change(subQuest)"
                >{{ subQuest.caption }}</a
              >
            </li>
          </ul>
        </li>
        <!-- ---------------  quests without sub-quests ------------------- -->
        <li v-else :key="'b-' + quest.id" :style="fontStyle(quest)">
          <a
            href="#"
            class="dropdown-item"
            :class="{active:isActive(quest)}"
            :style="fontStyle(quest)"
            @click.prevent="change(quest)"
            >{{ quest.caption }}</a
          >
        </li>
      </template>
    </ul>
  </li>
</template>

<script>
//---- mixins -------------
import QuestMenuMixins from "./QuestMenuMixins.js";

export default {
  mixins: [QuestMenuMixins],
  data() {
    return {
      opened: false,
      expandedQuest: null,
    };
  },

  methods: {
    change(quest) {
      this.hideDropDown();
      this.changeQuest(quest)
      this.$root.$emit("set-active-tab", "");
    },
    toggleExpand(id) {
      if (this.expandedQuest === id) {
        this.expandedQuest = null;
      } else { 
        this.expandedQuest = id;
      }
    },
    toggle() {
      if (this.opened) {
        this.opened = false;
        this.expandedQuest = null;
      }
      else 
        this.opened = true;
    },
    hideDropDown() {
      this.opened = false;
    },
    onClickedOutside() {
      this.opened = false;
      this.expandedQuest = null;
    },
    // method required for the directive
    popupClosed() {
      return !this.opened;
    },
  }, // end methods

  directives: {
    clickOutside: {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // only execute the rest if popup is opened
          if (vnode.context["popupClosed"]()) return;
          // here I check that click was outside the el and his childrens
          if (!(el == event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.body.removeEventListener("mouseup", el.clickOutsideEvent);
        document.body.addEventListener("mouseup", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("mouseup", el.clickOutsideEvent);
      },
    },
  }, // end directives
};
</script>
<style scoped>

a.dropdown-item.active {
  color: #fff;
  text-decoration: none;
  background-color: #007bff;
}
ul.branch {
  display: block;
}
.dropdown-submenu {
  position: relative;
}
.dropdown-submenu.active {
  background-color: #e4e7ff;
}
.dropdown-submenu > .dropdown-menu {
  top: 0;
  right: 95%;
  margin-top: -6px;
}
nav {
  width: auto !important;
}
.nav-link-custom {
  color: rgba(255, 255, 255, 0.5);
  padding: 0px 5px;
}
.nav-link-custom:hover {
  color: rgba(255, 255, 255, 0.75);
}
.dropdown-item-custom {
  display: block;
  width: 100%;
  padding: 0.25rem 1rem;
  clear: both;
  font-weight: 400;
  text-align: inherit;
  white-space: nowrap;
  border: 0;
  color: #16181b;
  text-decoration: none;
}
.dropdown-menu {
  float: left !important;
}
.dropdown-toggle {
    position:relative; top:-2px;
}
.icon {
    color: white;
}
.nav-item {
  width: 50px !important;
}
</style>